// React
import React from 'react';

// Utils
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

// Components
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ADGMImage from '../ADGMImage';

// styles
import styles from './styles';

/**
 * Reusable ADGMDropdown component.
 *
 * @param {string|JSX.Element} [title] - The title of the dropdown button. If not provided, the component will use <ADGMImage> as the title.
 * @param {Array} menuItems - An array of objects representing the menu items. Each object should have `label` and `onClick` properties.
 * @param {Object} classes - The CSS classes injected by withStyles.
 */
const ADGMDropdown = ({ title, menuItems, classes }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        variant='contained'
        aria-controls='adgm-dropdown-menu'
        aria-haspopup='true'
        onClick={handleClick}
        className={classes.dropdownButton}
        classes={{
          label: classes.dropdownButtonLabel,
        }}
      >
        {title ?? <ADGMImage name='menu-dotted.svg' alt='icon' width='auto' onClick={handleClick} />}
      </Button>
      <Menu
        id='adgm-dropdown-menu'
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        getContentAnchorEl={null}
        classes={{ paper: classes.dropdownMenu }}
        MenuListProps={{
          disablePadding: true,
        }}
      >
        {menuItems.map((menuItem, index) => (
          <MenuItem
            key={`${index + 1}`}
            onClick={() => {
              menuItem.onClick();
              handleClose();
            }}
          >
            {menuItem.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

ADGMDropdown.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    }),
  ).isRequired,
  classes: PropTypes.object.isRequired,
};

ADGMDropdown.defaultProps = {
  title: null,
};

export default withStyles(styles)(ADGMDropdown);
